const UPDATES = [
  {
    date: '7月28日',
    tag: '新番上线',
    title: '《怪兽8号》第二季预告公开，今秋开播确定',
    desc: '官方发布了全新视觉图和PV预告，日比野卡夫卡的战斗即将进入新篇章。',
  },
  {
    date: '7月27日',
    tag: '更新通知',
    title: '《地狱乐》番外篇上线，揭开幕府背后的秘密',
    desc: '画眉丸与佐切的过去终于揭晓，番外篇共三话一次性发布。',
  },
  {
    date: '7月26日',
    tag: '平台动态',
    title: '樱花漫画新增夜间模式，护眼阅读更舒适',
    desc: '深色主题全面适配，支持自动随系统切换，低光环境下阅读体验大幅提升。',
  },
  {
    date: '7月25日',
    tag: '专题策划',
    title: '暑假必读漫画30选：从经典到新番全覆盖',
    desc: '编辑团队精心整理暑期阅读书单，适合不同口味的漫画爱好者。',
  },
  {
    date: '7月24日',
    tag: '新番上线',
    title: '《坂本日常》动画化决定，杀手的日常即将开演',
    desc: '曾经的最强杀手坂本太郎的温馨搞笑日常，备受期待的动画改编。',
  },
  {
    date: '7月23日',
    tag: '读者福利',
    title: '夏日漫画马拉松活动开启，连续阅读赢好礼',
    desc: '参与每日阅读打卡即有机会获得限定周边和漫画兑换券。',
  },
  {
    date: '7月22日',
    tag: '更新通知',
    title: '《蓝色监狱》第二季追加声优阵容公开',
    desc: '全新角色登场，足球×生存游戏的激烈对决持续升温。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            最新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            漫画世界的最新资讯与平台动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 before:absolute before:left-3 before:top-2 before:bottom-2 before:w-px before:bg-background-300">
            {UPDATES.map((item, idx) => (
              <div key={idx} className="relative pb-6 last:pb-0">
                <div className="absolute -left-8 top-1 w-6 h-6 rounded-full bg-accent-500 flex items-center justify-center">
                  <div className="w-2 h-2 rounded-full bg-background-50"></div>
                </div>
                <div className="bg-background-100 rounded-xl border border-background-200/70 p-4 md:p-5 hover:border-accent-200 transition-colors cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500">{item.date}</span>
                    <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-accent-100 text-accent-800">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}